<template>
  <div class="footer container-fluid">
    <div class="widthSet">
      <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div> -->
      <div class="main_html">
        <h3>友情链接</h3>
        <div class="line"></div>
        <ul class="list cursorPointer">
          <li>
            <a target="_blank" href="https://www.sport.gov.cn/">国家体育总局</a>
          </li>
          <li>
            <a target="_blank" href="https://tyj.ln.gov.cn/">辽宁省体育局</a>
          </li>
          <li>
            <a target="_blank" href="http://tyj.shenyang.gov.cn/"
              >沈阳市体育局</a
            >
          </li>
          <li><a target="_blank" href="http://www.yoercn.com/">优尔科技</a></li>
          <li>
            <a target="_blank" href="https://www.chesscoacher.com/">众弈科技</a>
          </li>
          <li>
            <a target="_blank" href="http://www.mofang123.cn/"
              >辽宁魔方俱乐部</a
            >
          </li>
          <li>
            <a target="_blank" href="http://www.sysjyjjh.cn/"
              >沈阳市教育基金会</a
            >
          </li>
        </ul>
      </div>
      <!-- <p class="address_tel_fax">
      <span>地址：公司地址公司地址公司地址公司地址</span>
      <span>Tel：888-888-888</span>
      <span>Fax：8888-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：liyunkun_11@163.com</span>
      <span>公司微信号：ilyk_gg</span>
    </p> -->
      <div class="last">
        <!-- <div><a  href="javascript:void(0)">Copyright &copy; 2021-2031 沈阳市魔方运动协会 版权所有</a></div> -->
        <div>Copyright &copy; 2021-2031 沈阳市魔方运动协会 版权所有</div>
        <div>
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沈阳市魔方运动协会 辽ICP备15019503号</a
          >
        </div>
        <!-- <div><a  href="javascript:void(0)">沈阳市魔方运动协会 辽iCP备案2021015395号-1  技术支持：沈阳众弈教育信息咨询有限公司</a></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import '../assets/css/base.css';
export default {
  name: "Footer",
  data () {
    return {};
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  // height: 258px;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.widthSet {
  width: 1341px;
}

.main_html {
  padding-top: 20px;
}

.main_html h3 {
  font-size: 24px;
  color: #dfdfdf;
  margin-top: 10px;
  margin-bottom: 10px;
}

.main_html .line {
  width: 40px;
  height: 4px;
  background: #2eae95;
  border-radius: 5px;
  margin: 0 auto;
}

.list {
  /* 颜色未生效 */
  color: #cbcbcb;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.list li {
  margin-right: 60px;
}

.list li:last-child {
  margin-right: 0px;
}

.last {
  margin-top: 20px;
  margin-bottom: 25px;
}

.last div {
  /* 颜色未生效 */
  color: #abaaaa;
}

.last div a {
  color: #abaaaa;
  text-decoration: none;
}

.last div a:hover {
  // text-decoration: underline;
  cursor: pointer;
}
</style>
